/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faint_Pearl_Wren_LiftInputs */

const en_faint_pearl_wren_lift = /** @type {(inputs: Faint_Pearl_Wren_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit topic`)
};

const de_faint_pearl_wren_lift = /** @type {(inputs: Faint_Pearl_Wren_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit topic" |
*
* @param {Faint_Pearl_Wren_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_pearl_wren_lift = /** @type {((inputs?: Faint_Pearl_Wren_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Pearl_Wren_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_pearl_wren_lift(inputs)
	return de_faint_pearl_wren_lift(inputs)
});